import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function Rocketbook(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M7.26459 0C7.64087 0.139687 7.8247 0.434392 7.98106 0.785312C9.53082 4.30587 11.0875 7.82132
          12.651 11.3317C13.0565 12.2459 13.4574 13.1618 13.8537 14.0794C13.9546 14.2935 14.0129 14.5248
          14.0255 14.7608C14.0413 14.9078 14.0085 15.056 13.9319 15.1829C13.8554 15.3098 13.7393 15.4086
          13.6011 15.4643C13.4573 15.5148 13.3012 15.5189 13.1549 15.4761C13.0086 15.4332 12.8798 15.3457
          12.7867 15.2259C12.4774 14.8681 12.3245 14.4269 12.1373 14.0044C10.7765 10.9382 9.418 7.87186
          8.06181 4.80556L7.09278 2.62168C7.0756 2.5808 7.05326 2.53991 7.03092 2.49562C6.95017 2.54673
          6.93814 2.62509 6.90893 2.68982C5.41987 6.06274 3.92623 9.4351 2.42801 12.8069C2.15482 13.4218
          1.88164 14.0385 1.60502 14.6518C1.51441 14.8656 1.39032 15.064 1.23734 15.2395C1.14174 15.3569
          1.01139 15.4416 0.864658 15.4816C0.717926 15.5217 0.562218 15.515 0.419496 15.4626C0.280746
          15.4002 0.165737 15.2955 0.0912484 15.1637C0.0167596 15.032 -0.0133089 14.88 0.00542496
          14.7301C0.0411455 14.4257 0.130713 14.1299 0.270018 13.8562C1.61704 10.8127 2.96522 7.77022
          4.31453 4.72891C4.90729 3.39166 5.50693 2.05612 6.08766 0.713765C6.1475 0.555646 6.23869
          0.411019 6.35584 0.288426C6.473 0.165833 6.61374 0.0677601 6.76977 0L7.26459 0Z"
          fill="currentColor"
        />
        <path
          d="M7.59963 18.8762C7.59963 20.2151 7.59963 21.5558 7.59963 22.8964C7.59963 23.3887 7.26632 23.6238
          6.79039 23.4807C6.69665 23.456 6.61309 23.4028 6.55145 23.3285C6.48982 23.2543 6.4532 23.1627 6.44676
          23.0668C6.43644 22.9723 6.43299 22.8772 6.43645 22.7823V14.844C6.43645 14.2682 6.82475 14.1779 7.25772
          14.275C7.36486 14.298 7.45949 14.3598 7.52305 14.4484C7.58661 14.5369 7.61454 14.6458 7.60135
          14.7537C7.60135 15.2903 7.60135 15.8286 7.60135 16.3652L7.59963 18.8762Z"
          fill="currentColor"
        />
        <path
          d="M9.37106 17.5632C9.37106 16.6671 9.37106 15.77 9.37106 14.8717C9.37106 14.4083 9.56006 14.2311
          10.0274 14.2465C10.0876 14.2411 10.1482 14.2475 10.2058 14.2655C10.2635 14.2834 10.317 14.3124
          10.3632 14.3508C10.4095 14.3893 10.4477 14.4364 10.4756 14.4896C10.5035 14.5427 10.5205 14.6008
          10.5257 14.6604C10.5458 14.7671 10.5556 14.8755 10.5549 14.9841C10.5549 16.7239 10.5549 18.4643
          10.5549 20.2053C10.5549 20.2581 10.5549 20.3126 10.5549 20.3756C10.5575 20.4825 10.5307 20.588
          10.4774 20.681C10.4242 20.7739 10.3465 20.8507 10.2526 20.9032C10.1587 20.9557 10.0521 20.9819
          9.94438 20.979C9.83663 20.9761 9.73169 20.9442 9.64081 20.8867C9.39856 20.764 9.3745 20.546 9.37278
          20.3109C9.36935 19.3859 9.37106 18.4745 9.37106 17.5632Z"
          fill="currentColor"
        />
        <path
          d="M4.6616 17.5783C4.6616 18.4896 4.6616 19.3993 4.6616 20.3039C4.6616 20.8149 4.31797 21.0466
          3.8386 20.9018C3.75766 20.881 3.68426 20.838 3.62683 20.7777C3.56939 20.7175 3.53025 20.6424
          3.51388 20.5611C3.48744 20.4495 3.47532 20.335 3.47779 20.2204V14.9293C3.47779 14.8816 3.47779
          14.8339 3.47779 14.7879C3.50528 14.4166 3.68741 14.2462 4.05681 14.2462C4.42621 14.2462 4.63926
          14.4046 4.65644 14.7845C4.67362 15.1644 4.65644 15.5187 4.65644 15.885C4.66331 16.4505 4.6616
          17.0144 4.6616 17.5783Z"
          fill="currentColor"
        />
        <path
          d="M25.9918 6.39379C26.0706 6.27726 26.1718 6.1774 26.2895 6.09996C26.4073 6.02253 26.5392 5.96904
          26.6778 5.94258C27.9841 5.6461 29.3452 5.69216 30.6282 6.07627C31.8131 6.45824 32.5615 7.26993
          32.7102 8.52089C32.8685 9.88166 32.4295 10.9989 31.2327 11.7605C31.0902 11.8567 30.9373 11.9368
          30.7769 11.9992C30.5491 12.0756 30.5371 12.1544 30.6762 12.3478C31.4965 13.4626 32.3216 14.5918
          33.1395 15.7306C33.3266 15.986 33.5185 16.2343 33.6912 16.4969C33.9622 16.9075 33.8015 17.2561
          33.3146 17.3206C33.0791 17.3722 32.8334 17.352 32.6097 17.2626C32.3859 17.1731 32.1944 17.0186
          32.0602 16.8192C31.1487 15.4871 30.1845 14.1932 29.3066 12.8419C28.7981 12.0589 29.05 11.3021
          29.9159 10.9321C30.8225 10.5549 31.2087 9.86495 31.1151 8.78349C31.0456 7.96464 30.5011 7.39169
          29.5945 7.18638C28.9733 7.06113 28.3358 7.03695 27.7068 7.11476C27.5005 7.13624 27.5221 7.25561
          27.5221 7.3893V16.3107C27.5221 16.368 27.5221 16.4253 27.5221 16.4826C27.5101 16.8025 27.5005
          17.1224 27.1264 17.2609C26.9391 17.3351 26.7332 17.3487 26.5377 17.2999C26.3422 17.251 26.1672
          17.1422 26.0374 16.9887C26.0227 16.9799 26.0064 16.9742 25.9894 16.972L25.9918 6.39379Z"
          fill="currentColor"
        />
        <path
          d="M153.993 17.2639C153.542 17.3952 153.213 17.2281 152.909 16.8915C151.287 15.101 149.654 13.3105
          148.025 11.5367C147.721 11.2025 147.716 11.0592 148.025 10.7274C149.48 9.15017 150.94 7.57455 152.405
          6.00051C152.464 5.92603 152.54 5.86587 152.626 5.82453C152.712 5.78318 152.806 5.76173 152.901
          5.76178C153.017 5.76178 153.141 5.74984 153.204 5.87637C153.226 5.92984 153.231 5.989 153.217
          6.04524C153.203 6.10148 153.171 6.15188 153.127 6.1891C152.923 6.42784 152.717 6.64269 152.508
          6.86472C151.258 8.20639 150.006 9.54568 148.752 10.8826C148.615 11.0282 148.594 11.1213 148.74
          11.2693C150.467 13.1282 152.191 14.9927 153.911 16.8628C153.939 16.8869 153.969 16.9085 154
          16.9273L153.993 17.2639Z"
          fill="currentColor"
        />
        <path
          d="M43.3742 17.4378C41.64 17.4712 40.1337 16.9388 38.956 15.6354C38.1909 14.7713 37.7148 13.6917
          37.5937 12.5462C37.3759 11.1809 37.5923 9.78195 38.2125 8.54502C39.1095 6.82138 40.5799 5.90465
          42.4915 5.64921C43.5676 5.48667 44.6674 5.59416 45.6912 5.96195C47.7035 6.71634 48.8093 8.21319
          49.1811 10.2806C49.4585 11.6851 49.2699 13.1412 48.6438 14.4298C47.7995 16.1319 46.3819 17.0558
          44.5279 17.3781C44.1456 17.4292 43.7597 17.4492 43.3742 17.4378ZM43.4125 16.1391C45.5281 16.1391
          46.9408 15.1125 47.4757 13.1645C47.6706 12.4064 47.7275 11.6197 47.6436 10.8416C47.4445 8.45192
          45.8878 6.96462 43.4893 6.89777C41.5297 6.84764 40.0546 7.80018 39.4477 9.52383C39.1694 10.378
          39.073 11.2805 39.1647 12.1738C39.3398 14.6088 40.9708 16.1391 43.4125 16.1391V16.1391Z"
          fill="currentColor"
        />
        <path
          d="M59.0295 17.435C56.9499 17.3754 55.2134 16.6592 54.0884 14.8281C53.3521 13.6344 53.1626
          12.3047 53.249 10.9248C53.2839 10.23 53.4322 9.54545 53.6879 8.89799C53.9191 8.28961 54.2722
          7.73439 54.7258 7.26612C55.1794 6.79784 55.7239 6.42629 56.3263 6.17405C58.2595 5.36475 60.1808
          5.39579 62.054 6.39369C62.2231 6.48276 62.3802 6.59264 62.5217 6.72075C62.609 6.79778 62.6771
          6.89394 62.7207 7.00165C62.7643 7.10935 62.7821 7.22566 62.7728 7.34139C62.7635 7.45713 62.7273
          7.56913 62.6671 7.66857C62.6069 7.76801 62.5243 7.85217 62.4258 7.91441C62.3192 7.98066 62.1946
          8.01234 62.0691 8.00507C61.9437 7.9978 61.8236 7.95194 61.7254 7.87382C61.1802 7.53539 60.5866
          7.28105 59.9649 7.11943C58.2379 6.72791 56.3455 7.28416 55.4532 8.82159C54.9454 9.7481 54.7313
          10.8059 54.8392 11.8559C54.861 12.865 55.2158 13.839 55.849 14.6276C56.8084 15.7711 58.0844
          16.1745 59.5499 16.0456C60.3425 15.9507 61.1021 15.6736 61.7686 15.2363C61.8667 15.1578 61.9878
          15.1131 62.1136 15.1088C62.2394 15.1045 62.3632 15.1409 62.4666 15.2124C62.5803 15.2939 62.6684
          15.4058 62.7206 15.5351C62.7728 15.6644 62.7871 15.8059 62.7616 15.943C62.7336 16.0641 62.6796
          16.1777 62.6035 16.2762C62.5273 16.3746 62.4307 16.4556 62.3203 16.5135C61.699 16.9317 60.9933
          17.2096 60.2527 17.3276C59.8494 17.4023 59.4397 17.4383 59.0295 17.435V17.435Z"
          fill="currentColor"
        />
        <path
          d="M81.4655 11.5457V6.71139C81.4655 6.05488 81.6382 5.88538 82.3026 5.88538H86.4473C86.9654
          5.88538 87.1885 6.12411 87.1669 6.62067C87.1525 7.04084 86.927 7.24138 86.4473 7.24615C85.6702
          7.24615 84.893 7.24615 84.1159 7.24615C83.7993 7.24615 83.4827 7.24615 83.1565 7.24615C83.003
          7.24615 82.9622 7.29628 82.9622 7.4443C82.9622 8.36819 82.9622 9.29447 82.9622 10.2184C82.9622
          10.4261 83.0534 10.4571 83.2237 10.4571C84.0871 10.4571 84.9506 10.4571 85.8141 10.4571C86.3466
          10.4571 86.5648 10.6958 86.5337 11.221C86.5369 11.2933 86.5255 11.3654 86.5001 11.4332C86.4748
          11.5009 86.436 11.563 86.3861 11.6155C86.3362 11.6681 86.2762 11.7101 86.2097 11.7391C86.1431
          11.7681 86.0714 11.7836 85.9988 11.7844C85.3296 11.8561 84.658 11.8012 83.9864 11.8155C83.7178
          11.8155 83.4491 11.8155 83.1805 11.8155C83.0414 11.8155 82.9718 11.8465 82.9718 12.0041C82.9718
          13.224 82.9718 14.4439 82.9718 15.6662C82.9718 15.8715 83.0869 15.8644 83.2284 15.8644C84.4565
          15.8644 85.6846 15.8644 86.9126 15.8644C87.4931 15.8644 87.7473 16.1413 87.6778 16.6737C87.6734
          16.8195 87.6116 16.9578 87.5057 17.0588C87.3998 17.1597 87.2583 17.2152 87.1117 17.2132C86.8718
          17.2299 86.6152 17.2132 86.3658 17.2132H82.2546C81.6334 17.2132 81.4655 17.0461 81.4655
          16.4349V11.5457Z"
          fill="currentColor"
        />
        <path
          d="M136.467 17.4352C135.587 17.4742 134.711 17.2988 133.915 16.9243C132.777 16.4264 131.878
          15.5067 131.41 14.3603C131.031 13.4818 130.833 12.5365 130.827 11.5804C130.821 10.6242 131.007
          9.67649 131.375 8.79312C132.094 7.01457 133.485 6.01189 135.358 5.65857C136.388 5.45748 137.451
          5.50166 138.46 5.78749C139.22 5.98024 139.923 6.35186 140.51 6.87113C141.096 7.3904 141.549 8.04215
          141.83 8.77163C142.197 9.64087 142.386 10.5742 142.386 11.5171C142.386 12.4599 142.197 13.3932
          141.83 14.2625C141.086 16.0697 139.654 17.0532 137.74 17.3827C137.318 17.4349 136.892 17.4524
          136.467 17.4352V17.4352ZM141.571 11.4192C141.573 11.1139 141.551 10.8089 141.504 10.5072C141.264
          8.8719 140.544 7.53978 139.026 6.74719C138.093 6.28256 137.044 6.10235 136.009 6.22914C134.049
          6.41774 132.651 7.39176 131.981 9.26819C131.511 10.6 131.47 12.0445 131.864 13.4006C132.26 14.833
          133.125 15.8954 134.541 16.4421C135.768 16.9204 137.125 16.9592 138.378 16.5519C139.005 16.3659
          139.58 16.0378 140.059 15.5934C140.537 15.1489 140.905 14.6002 141.134 13.9903C141.45 13.1706
          141.598 12.2966 141.571 11.4192V11.4192Z"
          fill="currentColor"
        />
        <path
          d="M122.162 17.4304C121.004 17.5053 119.855 17.1927 118.897 16.5424C117.698 15.7569 117.041
          14.6039 116.715 13.2383C116.529 12.4512 116.472 11.6395 116.544 10.8343C116.669 9.33743 117.17
          7.98382 118.317 6.93578C119.054 6.26355 119.974 5.82404 120.962 5.67289C122.097 5.46396
          123.265 5.53362 124.366 5.87581C125.142 6.10797 125.848 6.52838 126.42 7.09926C126.992 7.67014
          127.413 8.37361 127.645 9.14644C128.263 10.8777 128.183 12.7804 127.419 14.4535C126.685 16.0601
          125.369 16.9578 123.658 17.3182C123.166 17.4162 122.663 17.4539 122.162 17.4304V17.4304ZM122.262
          16.8121C122.578 16.8193 122.893 16.8001 123.205 16.7548C124.862 16.4803 126.129 15.6662 126.776
          14.0882C127.447 12.4824 127.463 10.6798 126.82 9.06289C126.614 8.49427 126.285 7.97727 125.858
          7.54801C125.43 7.11876 124.914 6.7876 124.344 6.57769C123.157 6.11231 121.846 6.06181 120.627
          6.43444C119.928 6.62274 119.289 6.98433 118.77 7.48536C118.25 7.98639 117.866 8.61049 117.655
          9.29923C117.2 10.6559 117.172 12.1186 117.576 13.4914C117.814 14.3855 118.331 15.1812 119.053
          15.7641C119.96 16.4831 121.096 16.8549 122.255 16.8121H122.262Z"
          fill="currentColor"
        />
        <path
          d="M110.466 10.9004C110.886 10.9898 111.295 11.1193 111.69 11.2872C112.975 11.8983 113.455
          13.0753 113.333 14.3453C113.198 15.7156 112.407 16.5775 111.131 16.9953C109.953 17.3542
          108.706 17.427 107.495 17.2077C107.056 17.1409 106.962 17.0072 106.962 16.5751V6.44807C106.962
          6.04461 107.056 5.90137 107.459 5.84885C108.509 5.71278 109.562 5.65787 110.596 5.94912C111.74
          6.27141 112.433 7.02819 112.498 7.98789C112.587 9.32241 112.081 10.1986 110.917 10.7214C110.788
          10.7787 110.649 10.8288 110.466 10.9004ZM107.67 11.5044V16.3363C107.67 16.4748 107.634 16.6157
          107.862 16.6395C108.814 16.7636 109.782 16.702 110.711 16.4581C111.373 16.2647 111.949 15.9353
          112.285 15.3003C113.023 13.9061 112.414 12.2827 110.913 11.6548C110.299 11.4052 109.64 11.2849
          108.977 11.3015C108.929 11.3093 108.88 11.3058 108.834 11.291C108.788 11.2763 108.746 11.2508
          108.712 11.2167C108.678 11.1827 108.652 11.141 108.637 11.0951C108.622 11.0492 108.619 11.0005
          108.627 10.9529C108.627 10.7142 108.754 10.6163 108.989 10.6235C109.383 10.6317 109.775 10.5744
          110.15 10.454C110.615 10.3386 111.026 10.0691 111.316 9.6898C111.607 9.31054 111.759 8.84416
          111.747 8.36748C111.733 7.43642 111.162 6.78707 110.109 6.50298C109.407 6.3508 108.683 6.3161
          107.97 6.40032C107.73 6.41703 107.663 6.51492 107.663 6.75604C107.677 8.32928 107.67 9.92162
          107.67 11.5044Z"
          fill="currentColor"
        />
        <path
          d="M75.8937 17.3234C75.6911 17.3307 75.4898 17.2891 75.3069 17.2023C75.1239 17.1154 74.9648 16.9858
          74.8431 16.8244C74.1187 15.9857 73.3992 15.1461 72.6844 14.3058C72.0128 13.5228 71.3412 12.7397
          70.6792 11.9495C70.1467 11.3169 70.1491 10.9612 70.6792 10.3429C71.8329 9.00596 72.9962 7.67622
          74.1499 6.33933C74.3016 6.14126 74.5014 5.98479 74.7304 5.88457C74.9595 5.78436 75.2104 5.74368
          75.4595 5.76637C75.6994 5.78546 75.9392 5.80456 76.0448 6.05046C76.1503 6.29635 76.0016 6.47301
          75.8505 6.64013C74.5937 8.04148 73.344 9.44523 72.0776 10.8347C71.8953 11.0352 71.8929 11.1402
          72.0776 11.3431C73.5311 12.9999 74.9774 14.6647 76.4166 16.3374C76.5821 16.5284 76.8051 16.7313
          76.6564 17.0154C76.5077 17.2995 76.1815 17.3091 75.8937 17.3234Z"
          fill="currentColor"
        />
        <path
          d="M69.6838 11.5625C69.6838 13.2336 69.6838 14.9048 69.6838 16.5759C69.6838 17.1202 69.444
          17.3327 68.9067 17.3303C68.3694 17.3279 68.132 17.1035 68.132 16.5377C68.132 14.5928 68.132
          12.648 68.132 10.7031C68.132 9.32083 68.132 7.93857 68.132 6.55632C68.132 5.98814 68.3718
          5.76134 68.9475 5.77327C69.4608 5.78521 69.6814 5.9953 69.6838 6.51096C69.6862 8.18924 69.6838
          9.87469 69.6838 11.5625Z"
          fill="currentColor"
        />
        <path
          d="M97.3104 12.5739V16.6085C97.3104 17.0859 97.1017 17.3032 96.6172 17.3247C96.0607 17.3414
          95.8113 17.148 95.7729 16.661C95.7729 16.556 95.7729 16.4509 95.7729 16.3459V8.84731C95.7729
          8.77091 95.7729 8.69452 95.7729 8.60858C95.7897 8.34358 95.7729 8.06188 96.0823 7.92342C96.2319
          7.84937 96.3973 7.81243 96.5644 7.81576C96.7314 7.81908 96.8952 7.86257 97.0417 7.94252C97.1364
          7.99983 97.2121 8.08353 97.2594 8.18326C97.3067 8.28299 97.3236 8.39435 97.308 8.50353C97.308
          9.86669 97.3104 11.2203 97.3104 12.5739Z"
          fill="currentColor"
        />
        <path
          d="M96.5692 5.88549C97.874 5.88549 99.1764 5.88549 100.481 5.88549C100.961 5.88549 101.184
          6.09319 101.201 6.51097C101.225 6.98844 100.975 7.24627 100.436 7.24865C98.4624 7.24865
          96.4876 7.24865 94.5112 7.24865C93.8684 7.24865 93.2256 7.24865 92.5924 7.24865C92.1127
          7.24865 91.892 6.99082 91.916 6.53246C91.9352 6.10513 92.1558 5.89982 92.6355 5.89982C93.9428
          5.88311 95.2572 5.88549 96.5692 5.88549Z"
          fill="currentColor"
        />
        <path
          d="M146.454 11.5122C146.454 9.7281 146.454 7.94557 146.454 6.16463C146.454 5.8304 146.572
          5.72536 146.881 5.7564C146.949 5.75363 147.015 5.77682 147.067 5.8212C147.118 5.86559 147.15
          5.92782 147.157 5.99513C147.17 6.09889 147.177 6.2033 147.178 6.30787C147.178 9.79813 147.178
          13.2868 147.178 16.7739C147.178 17.1917 147.061 17.3421 146.764 17.3086C146.512 17.28 146.447
          17.1224 146.447 16.8885C146.457 15.0956 146.454 13.3051 146.454 11.5122Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
